import React from "react";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Col, Row } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import PropTypes from "prop-types";
import styled from "styled-components";

const { SearchBar } = Search;

const RemoteTable = ({
  data: { page = 1, sizePerPage = 10, count = 0, results = [], size },
  onTableChange,
  columns,
  children,
  children_total,
  selectRow,
  loading = false,
  search_input = true,
  bordered = false,
  disable_pages = false,
  total_info = false,
  disableTable = false,
  breadcrumbComponent,
  rowClasses = () => { },
  onClick = function () { },
}) => {
  const pageOptions = {
    sizePerPage: parseInt(size || sizePerPage || 10),
    totalSize: count,
    page: parseInt(page),
    custom: true,
  };

  const handleChangeTable = (
    type,
    { page, searchText, sizePerPage, sortField, sortOrder }
  ) => {
    let ordering = "";
    if (type === "search") page = 1;
    if (sortField) {
      if (sortOrder === "desc") {
        ordering = sortField;
      } else {
        ordering = `-${sortField}`;
      }
    }
    onTableChange({
      page,
      search: searchText,
      sizePerPage,
      ordering,
    });
  };

  const rowEvents = {
    onClick,
  };

  const emptyDataMessage = () => {
    return (
      <Row className="align-items-center text-center mt-4">
        <Col xs={12}>
          <i
            className="dripicons-archive"
            style={{ fontSize: "130px", opacity: "0.2" }}
          />
          <p style={{ opacity: "0.2" }}>Oops, no data found...</p>
        </Col>
      </Row>
    );
  };

  return (
    <PaginationProvider
      remote
      pagination={paginationFactory(pageOptions)}
      keyField="id"
      columns={columns}
      data={results}
    >
      {({ paginationProps, paginationTableProps }) => {
        return (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            // data={this.state.productData}
            data={results}
            // filter={filterFactory()}
            search
            remote
          >
            {toolkitProps => (
              <React.Fragment>

                {breadcrumbComponent && (
                  <Row className="mb-4">
                    <Col>
                      {breadcrumbComponent}
                    </Col>
                  </Row>
                )}

                <Row className="mb-2">
                  {search_input && (
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar
                            delay={900}
                            {...toolkitProps.searchProps}
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                  )}
                  <Col sm={search_input ? "8" : "12"}>
                    <div className="text-sm-end">{children}</div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <TableContent className="table-responsive">
                      {loading && (
                        <div className="table-loader">
                          <div
                            className="spinner-border text-primary m-1"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      )}
                      <BootstrapTable
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                        keyField={"id"}
                        responsive
                        bordered={bordered}
                        striped={false}
                        rowEvents={rowEvents}
                        hover={true}
                        // defaultSorted={defaultSorted}
                        // selectRow={selectRow}
                        selectRow={selectRow}
                        filter={filterFactory()}
                        classes={`table align-middle table-nowrap fade-in-custom-animate ${disableTable && "d-none"
                          }`}
                        noDataIndication={emptyDataMessage}
                        remote
                        onTableChange={handleChangeTable}
                        headerWrapperClasses={"thead-light"}
                        rowClasses={rowClasses}
                      />
                    </TableContent>
                  </Col>
                </Row>
                {total_info && (
                  <Row className="align-items-md-center mt-3">
                    <Col className="inner-custom-pagination d-flex">
                      {children_total}
                    </Col>
                  </Row>
                )}
                {!disable_pages && (
                  <Row className="align-items-md-center mt-3">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            )}
          </ToolkitProvider>
        );
      }}
    </PaginationProvider>
  );
};

const TableContent = styled.div`
  position: relative;

  .table-loader {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
  }

  .table {
    margin-bottom: 0;
  }
`;
RemoteTable.propTypes = {
  data: PropTypes.any,
  columns: PropTypes.array.isRequired,
  // page: PropTypes.number.isRequired,
  // totalSize: PropTypes.number.isRequired,
  // sizePerPage: PropTypes.number.isRequired,
  disablePageSettings: PropTypes.bool,
  onTableChange: PropTypes.func.isRequired,
  children: PropTypes.any,
  children_total: PropTypes.any,
  total_info: PropTypes.bool,
  selectRow: PropTypes.any,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  search_input: PropTypes.bool,
  disable_pages: PropTypes.bool,
  bordered: PropTypes.bool,
  disableTable: PropTypes.bool,
  rowClasses: PropTypes.any,
  breadcrumbComponent: PropTypes.any,
};

export default RemoteTable;
